<template>
  <div class="main-content " id="layout-one" v-if="activeLayout === 1">
    <keep-alive>
      <component :is="activeTab.component" />
    </keep-alive>
  </div>
  <div class="main-content " id="layout-two" v-else-if="activeLayout === 2">
    <div class="half-tab">
      <HomeTab />
    </div>
    <div class="half-tab">
      <component
        v-if="spaceIsOccupied('space2Tab')"
        :is="space2Tab.component"
      />
      <tab-selection
        v-if="showSpaceTabSelection(2)"
        :openTabs="unusedOpenTabs"
        @selectTab="selectSpaceTab($event, 2, 2)"
      />
    </div>
  </div>
  <div class="main-content" id="layout-three" v-else-if="activeLayout === 3">
    <div class="half-tab">
      <HomeTab />
    </div>
    <div class="quarter-tab">
      <component
        v-if="spaceIsOccupied('space2Tab')"
        :is="space2Tab.component"
      />
      <tab-selection
        v-if="showSpaceTabSelection(2)"
        :openTabs="unusedOpenTabs"
        @selectTab="selectSpaceTab($event, 3, 2)"
      />
    </div>
    <div class="quarter-tab">
      <component
        v-if="spaceIsOccupied('space3Tab')"
        :is="space3Tab.component"
      />
      <tab-selection
        v-if="showSpaceTabSelection(3)"
        :openTabs="unusedOpenTabs"
        @selectTab="selectSpaceTab($event, 3, 3)"
      />
    </div>
  </div>
  <div class="main-content" id="layout-four" v-else-if="activeLayout === 4">
    <div class="quarter-tab">
      <HomeTab />
    </div>
    <div class="quarter-tab">
      <component
        v-if="spaceIsOccupied('space2Tab')"
        :is="space2Tab.component"
      />
      <tab-selection
        v-if="showSpaceTabSelection(2)"
        :openTabs="unusedOpenTabs"
        @selectTab="selectSpaceTab($event, 4, 2)"
      />
    </div>
    <div class="quarter-tab">
      <component
        v-if="spaceIsOccupied('space3Tab')"
        :is="space3Tab.component"
      />
      <tab-selection
        v-if="showSpaceTabSelection(3)"
        :openTabs="unusedOpenTabs"
        @selectTab="selectSpaceTab($event, 4, 3)"
      />
    </div>
    <div class="quarter-tab">
      <component
        v-if="spaceIsOccupied('space4Tab')"
        :is="space4Tab.component"
      />
      <tab-selection
        v-if="showSpaceTabSelection(4)"
        :openTabs="unusedOpenTabs"
        @selectTab="selectSpaceTab($event, 4, 4)"
      />
    </div>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import TabSelection from "./TabSelection";
import HomeTab from "../Content/MapT";

export default {
  name: "FibercloudMainContent",

  components: {
    TabSelection,
    HomeTab
  },

  data() {
    return {
      activeTab: {
        name: "home",
        display: "OutsidePlan",
        component: HomeTab,
        open: true,
        disabled: false,
        dev: false
      },
      openTabs: [
        {
          name: "home",
          display: "OutsidePlan",
          component: HomeTab,
          open: true,
          disabled: false,
          dev: false
        }
      ],
      /** Currently active layout mode or number of tabs opened side by side. */
      activeLayout: 1,
      /** Object containing the info of the tab currently in the 2nd space (layout mode 2 to 4) */
      space2Tab: null,
      /** Object containing the info of the tab currently in the 3rd space (layout mode 3 to 4) */
      space3Tab: null,
      /** Object containing the info of the tab currently in the 4th space (layout mode 4) */
      space4Tab: null
    };
  },

  computed: {
    /**
     * Creates an array of objects corresponding to the open tabs that are not visible (specially in the layout mode).
     * @returns {array}
     */
    unusedOpenTabs() {
      let unused = [];
      this.openTabs.forEach(tab => {
        if (
          tab.name !== "home" &&
          this.space2Tab !== tab &&
          this.space3Tab !== tab &&
          this.space4Tab !== tab
        ) {
          unused.push(tab);
        }
      });
      return unused;
    }
  },

  watch: {
    activeLayout(newValue) {
      this.$store.dispatch("SET_ACTIVE_LAYOUT_MODE", newValue);
    }
  },

  mounted() {
    bus.$on("updateActiveLayout", newValue =>
      this.updateActiveLayout(newValue)
    );
    bus.$on("updateActiveTab", newValue => {
      this.updateActiveTab(newValue);
    });
    bus.$on("updateOpenTabs", newValue => {
      this.openTabs = newValue;
    });
    this.updateMap();
  },

  updated() {
    this.updateMap();
  },

  destroyed() {
    bus.$off("updateActiveLayout");
    bus.$off("updateActiveTab");
    bus.$off("updateOpenTabs");
  },

  methods: {
    /**
     *Updates the layout to a value chosen elsewhere.
     * @param {Number} newLayout
     */
    updateActiveLayout(newLayout) {
      this.updateMap();
      this.activeLayout = newLayout;
      if (newLayout >= 2) {
        this.resetSpaceTabs();
      }
      if (newLayout === 2 && this.openTabs.length === newLayout) {
        this.space2Tab = this.openTabs[1];
      }
    },
    /**
     *Updates the active tab to a tab chosen elsewhere.
     * @param {Number} newActiveTab
     */
    updateActiveTab(newActiveTab) {
      this.activeTab = newActiveTab;
      if (this.activeLayout === 2) {
        this.selectSpaceTab(newActiveTab, 2, 2);
      }
    },
    /** Emits an event to update the size of the map **/
    updateMap() {
      this.$nextTick(() => {
        bus.$emit("update-map-size");
      });
    },

    /**
     * Generates a layout space name based on the space number.
     * @param {number} space - number of the space in the layout.
     * @return {string} the name of the space.
     */
    getSpaceName(space) {
      return "space" + space + "Tab";
    },
    /**
     * Checks if a certain layout space is occupied or not.
     * @param {string} spaceName - name of the space in the layout.
     * @return {boolean}.
     */
    spaceIsOccupied(spaceName) {
      return this[spaceName] !== null;
    },

    /** Resets all the layout spaces except the first.**/
    resetSpaceTabs() {
      this.space2Tab = null;
      this.space3Tab = null;
      this.space4Tab = null;
    },
    /**
     * Places a selected tab in a selected space.
     * @param {object} tab - Object containing the info of the selected tab
     * @param {number} layout - Layout mode selected
     * @param {number} space - Space selected
     */
    selectSpaceTab(tab, layout, space) {
      let spaceName = this.getSpaceName(space);
      this[spaceName] = tab;
      if (space === layout - 1 && this.unusedOpenTabs.length === 1) {
        this[this.getSpaceName(layout)] = this.unusedOpenTabs[0];
      }
    },
    /**
     * Determines if the Space should appear in Tab selection mode or not .
     * @param {number} space - Space selected
     */
    showSpaceTabSelection(space) {
      if (this.unusedOpenTabs.length > 1) {
        for (let i = 2; i < space; i++) {
          let spaceName = this.getSpaceName(i);
          if (this[spaceName] === null) return false;
        }
        let spaceName = this.getSpaceName(space);
        return this[spaceName] === null;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.main-content {
  background-color: var(--screen);
  position: absolute;
  left: 36px;
  top: 32px;
  height: calc(100vh - 32px - 18px);
  width: calc(100vw - 36px);
  z-index: 2;
  display: flex;
}

.half-tab {
  width: 50%;
  height: 100%;
  border: 1px solid var(--secondary-lighter);
}
.quarter-tab {
  width: 50%;
  height: 50%;
  border: 1px solid var(--secondary-lighter);
}
#layout-three {
  flex-wrap: wrap;
  flex-direction: column;
}
#layout-four {
  flex-wrap: wrap;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/MainContent.vue